
<div
  id="app"
  class="grid grid-cols-1 grid-flow-rows bg-gray-700 h-screen overflow-hidden"
  :class="[colorScheme]"
>
  <router-view />
  <portal name="modal" />
</div>
